// src/components/common/LanguageSelector.jsx
import React from 'react';
import { useTranslation } from '../../i18n';

const LanguageSelector = () => {
  const { lang, changeLanguage } = useTranslation();

  const languages = [
    { code: 'fr', label: 'FR', title: 'Français', flag: '🇫🇷' },
    { code: 'en', label: 'EN', title: 'English', flag: '🇬🇧' },
    { code: 'ar', label: 'عربي', title: 'العربية', flag: '🇸🇦' },
  ];

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
  };

  return (
    <div className="flex gap-1 bg-white/10 backdrop-blur-sm rounded-lg p-1 border border-white/5">
      {languages.map((lng) => (
        <button
          key={lng.code}
          onClick={() => handleLanguageChange(lng.code)}
          className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-all duration-200 flex items-center gap-1.5 cursor-pointer ${
            lang === lng.code
              ? 'bg-ofd-yellow text-ofd-slate shadow-lg'
              : 'text-white/60 hover:text-white/90 hover:bg-white/5'
          }`}
          title={lng.title}
          type="button"
        >
          <span className="text-sm">{lng.flag}</span>
          <span>{lng.label}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;